export default __webpack_public_path__ + "static/media/8.a2e333eb.png";